import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Resortnearpuneforevents() {



    const cardData =
    {
        keyword: 'Resort Near Pune for Event Celebration Morachi Chincholi',
        heading: 'Anand Krushi Paryatan Kendra: Resort Near Pune for Event Celebration Morachi Chincholi',
        headingDescription: 'Searching for the ideal resort near Pune for event celebration Morachi Chincholi? Look no further than Anand Krushi Paryatan Kendra, a serene 40-acre agri-tourism retreat just 55 km from Pune. Perfect for birthdays, anniversaries, engagements, family get-togethers, and corporate gatherings, this eco-friendly resort blends rural charm with modern amenities to make your event truly memorable. The venue offers spacious outdoor and semi-covered areas for hosting all kinds of celebrations. Guests can enjoy traditional and fun-filled activities like bullock cart and tractor rides, horse riding, boating, swimming, rain dance, and cultural shows including puppetry and magic.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Open-Air Celebration Lawns",
    "description": "Host your special event in sprawling green lawns surrounded by peacock-dotted farms and mango trees. Perfect for weddings, birthdays, or large group celebrations with flexible seating, floral décor options, and scenic village charm."
  },
  {
    "title": "Traditional Maharashtrian Catering",
    "description": "Treat guests to authentic farm-fresh Maharashtrian food—served on banana leaves or buffet-style—with dishes like pithla-bhakri, varan-bhat, puranpoli, and seasonal vegetables cooked on wood-fired chulhas."
  },
  {
    "title": "Farm-Theme Decor & Rural Ambience",
    "description": "Celebrate amidst rustic decor—bamboo arches, bullock cart photo spots, and lantern-lit trails. The peaceful countryside offers a refreshing backdrop that brings simplicity and warmth to every occasion."
  },
  {
    "title": "Private Rain Dance & Pool Zone",
    "description": "Make your celebration lively with a private rain dance area, splash pool access, and DJ music. This is especially popular for birthdays, family reunions, and youth-centric events seeking both energy and entertainment."
  },
  {
    "title": "Cultural Folk Entertainment",
    "description": "Add charm with live folk performances—lavani, dhol-tasha, lezim, or puppet shows. Resorts often include these in celebration packages, turning events into cultural showcases of rural Maharashtra."
  },
  {
    "title": "Overnight Cottage & Dorm Stay",
    "description": "Stay overnight in village-style cottages or dormitories with modern comforts. Ideal for two-day events, corporate retreats, or wedding guests who want to enjoy night bonfires and early morning nature walks."
  },
  {
    "title": "Tractor Ride Entry & Event Welcome",
    "description": "Surprise guests with a traditional village welcome—dhol-tasha entry, turmeric-tilak, and a tractor or bullock cart ride to the main event venue. It adds an unforgettable, fun-filled start to any celebration."
  },
  {
    "title": "Games & Activities for All Ages",
    "description": "Keep everyone engaged with rural games (like sack race, lagori), swings for kids, and rope walks for adults. These add interactive charm to events and keep the festive mood alive from start to finish."
  },
  {
    "title": "Campfire & Evening Music",
    "description": "Wrap up the celebration with an optional bonfire and live dholki music or karaoke under the stars. Great for intimate events, group singing, and heartfelt moments in a relaxed natural setting."
  },
  {
    "title": "Custom Packages & Group Bookings",
    "description": "Choose from event-specific packages tailored to your needs—birthday parties, anniversaries, corporate gatherings, school reunions, or festive family celebrations. Group discounts and full-farm bookings available on request."
  }
],




"services": [
  {
    "name": "Event Venues at Morachi Chincholi Resorts",
    "description": "Resorts offering versatile indoor and outdoor venues perfect for hosting various events with scenic rural backdrops, lush greenery, and modern amenities."
  },
  {
    "name": "Birthday Party Resorts",
    "description": "Family-friendly resorts with kid-safe play areas, themed decoration options, poolside party zones, and entertainment facilities to make birthdays fun and hassle-free."
  },
  {
    "name": "Wedding Celebration Resort Options",
    "description": "Spacious lawns, elegant banquet halls, and rustic farm settings to host traditional and contemporary weddings, including arrangements for cultural rituals and pre-wedding shoots."
  },
  {
    "name": "Corporate Function Resorts Near Pune",
    "description": "Resorts equipped with conference rooms, team-building activity zones, AV equipment, and catering to organize corporate retreats, meetings, and celebrations in a refreshing atmosphere."
  },
  {
    "name": "Family Event Spaces in Resorts",
    "description": "Comfortable and cozy spaces designed for family gatherings, anniversaries, reunion parties with spacious dining areas and recreational activities for all ages."
  },
  {
    "name": "Outdoor Event Lawns",
    "description": "Large open lawns with rustic charm and flexible seating arrangements, perfect for open-air events like music nights, cultural shows, and casual get-togethers."
  },
  {
    "name": "Affordable Celebration Resorts",
    "description": "Budget-friendly resorts offering great value without compromising on quality, including customizable packages for food, décor, and entertainment."
  },
  {
    "name": "Resorts with DJ & Party Setup",
    "description": "Venues with professional DJ services, sound systems, dance floors, and lighting setups for vibrant parties and celebrations."
  },
  {
    "name": "Poolside Celebration Venues",
    "description": "Resorts featuring beautiful poolsides perfect for intimate parties, cocktail events, and relaxing celebrations with a scenic view."
  },
  {
    "name": "Kids Party Resorts",
    "description": "Resorts providing kid-friendly amenities such as play zones, safe swimming pools, fun games, and supervised activities to keep little guests entertained."
  },
  {
    "name": "Anniversary Celebration Venues",
    "description": "Romantic and serene resort settings to celebrate anniversaries with special décor, candlelight dinners, and personalized services."
  },
  {
    "name": "Customized Event Décor Options",
    "description": "Flexible decoration themes including traditional rural, rustic chic, floral, and cultural motifs tailored to your event style and preferences."
  },
  {
    "name": "One-Day Event Celebration Packages",
    "description": "All-inclusive day packages covering venue rental, catering, décor, entertainment, and event coordination for seamless celebrations."
  },
  {
    "name": "Event Catering Available at Resorts",
    "description": "Resorts offering diverse catering menus with local Maharashtrian delicacies, organic farm-to-table meals, and customized food options for all dietary needs."
  },
  {
    "name": "Group Stay + Event Combo Packages",
    "description": "Convenient packages combining comfortable overnight stays with event hosting facilities, making it easy for guests to enjoy multi-day celebrations."
  }
],
"tableData": [
  ["Event Venues at Morachi Chincholi Resorts", "- Birthday Party Resorts"],
  ["Wedding Celebration Resort Options", "- Corporate Function Resorts Near Pune"],
  ["Family Event Spaces in Resorts", "- Outdoor Event Lawns"],
  ["Affordable Celebration Resorts", "- Resorts with DJ & Party Setup"],
  ["Poolside Celebration Venues", "- Kids Party Resorts"],
  ["Anniversary Celebration Venues", "- Customized Event Décor Options"],
  ["One-Day Event Celebration Packages", "- Event Catering Available at Resorts"],
  ["Group Stay + Event Combo Packages", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Fun-Filled Water Activities",
    "WhyChoosedescription": "Morachi Chincholi Water Park offers a variety of water-based attractions including slides, splash pools, and wave pools. It’s perfect for families and groups looking to beat the heat while enjoying thrilling water rides in a safe environment."
  },
  {
    "WhyChooseheading": "Family-Friendly Ambiance",
    "WhyChoosedescription": "The park is designed to cater to all age groups with separate zones for kids and adults, ensuring a comfortable and enjoyable experience for everyone from toddlers to grandparents."
  },
  {
    "WhyChooseheading": "Scenic Location Surrounded by Nature",
    "WhyChoosedescription": "Situated amidst lush greenery and close to the famous Peacock Village, the water park combines natural beauty with modern recreational facilities, providing a refreshing day out near Pune."
  },
  {
    "WhyChooseheading": "Additional Entertainment and Amenities",
    "WhyChoosedescription": "Besides water fun, visitors can enjoy food courts offering local and international cuisine, shaded rest areas, and well-maintained washrooms, making the visit convenient and comfortable."
  },
  {
    "WhyChooseheading": "Ideal Weekend Getaway",
    "WhyChoosedescription": "Located just around 50-60 km from Pune, the water park is an ideal spot for a quick and refreshing day trip, offering a perfect mix of excitement and relaxation for families, friends, and corporate groups."
  }
]


























    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Are there resorts near Pune in Morachi Chincholi for event celebrations?',
    answer: 'Yes, Morachi Chincholi offers several resorts near Pune that specialize in hosting event celebrations such as birthdays, weddings, corporate functions, and more.',
  },
  {
    id: 'FAQ2',
    question: 'What types of events can be celebrated at these resorts?',
    answer: 'You can celebrate birthdays, anniversaries, weddings, corporate events, family reunions, and other special occasions.',
  },
  {
    id: 'FAQ3',
    question: 'Do resorts provide event planning and decoration services?',
    answer: 'Many resorts offer event planning, decoration, catering, and entertainment services to ensure a seamless celebration experience.',
  },
  {
    id: 'FAQ4',
    question: 'Are there indoor and outdoor venues available at the resorts?',
    answer: 'Yes, resorts provide both indoor banquet halls and outdoor spaces suitable for different types of events and group sizes.',
  },
  {
    id: 'FAQ5',
    question: 'Is accommodation available for guests attending the event?',
    answer: 'Most resorts offer comfortable accommodation options for guests to stay overnight, making it convenient for multi-day celebrations.',
  },
  {
    id: 'FAQ6',
    question: 'Can catering be customized according to event requirements?',
    answer: 'Yes, catering menus can be tailored to suit your preferences, including traditional Maharashtrian dishes and other cuisines.',
  },
  {
    id: 'FAQ7',
    question: 'What safety measures are in place at the resorts?',
    answer: 'Resorts follow strict hygiene and safety protocols including sanitization, social distancing, and staff training to ensure guest safety.',
  },
  {
    id: 'FAQ8',
    question: 'How far is Morachi Chincholi from Pune city?',
    answer: 'Morachi Chincholi is approximately 60-65 km from Pune, making it easily accessible for day trips and event celebrations.',
  },
  {
    id: 'FAQ9',
    question: 'How can I book a resort for an event in Morachi Chincholi?',
    answer: 'You can contact resorts directly through their websites or phone numbers to inquire about availability, packages, and bookings.',
  },
  {
    id: 'FAQ10',
    question: 'Are there any special event packages offered by the resorts?',
    answer: 'Yes, many resorts offer special packages that include venue, catering, decoration, and activities at competitive prices.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshpande, Pune',
    feedback: "We celebrated our family reunion at a resort in Morachi Chincholi. The event was well-organized, and the serene surroundings made it extra special.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Joshi, PCMC',
    feedback: "The resort provided excellent service and beautiful decor for our wedding function. Highly recommend Morachi Chincholi for event celebrations near Pune.",
    rating: 5,
  },
];





























    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Resort Near Pune for Event Celebration Morachi Chincholi",
  "image": "https://morachichincholi.in/assets/images/resort-event-celebration.jpg",
  "description": "Event venues at Morachi Chincholi resorts offering birthday parties, weddings, corporate functions, family events, outdoor lawns, DJ setups, poolside celebrations, and customized event décor with catering and group stay packages.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "720"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/resort-event-celebration"
  }
};



    return (
        <div>
<Helmet>
  <title>Resort Near Pune for Event Celebration Morachi Chincholi | Birthday, Wedding & Corporate Events</title>
  <meta 
    name="description" 
    content="Celebrate your events at Morachi Chincholi resorts with birthday party setups, wedding venues, corporate functions, family event spaces, outdoor lawns, DJ & party setups, poolside celebrations, and customized décor options." 
  />
  <meta 
    name="keywords" 
    content="Event venues Morachi Chincholi resorts, Birthday party resorts, Wedding celebration resort options, Corporate function resorts near Pune, Family event spaces in resorts, Outdoor event lawns, Affordable celebration resorts, Resorts with DJ & party setup, Poolside celebration venues, Kids party resorts, Anniversary celebration venues, Customized event décor options, One-day event celebration packages, Event catering available at resorts, Group stay + event combo packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/33.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Resortnearpuneforevents;